import Page from "../../layout/Page";
import PageHeader from "../../layout/PageHeader";
import {MessagesList} from "./MessagesList";

export const MessagesPage = () => {
   return <Page>
      <PageHeader title={"Messages sent to connectors"}>
      </PageHeader>
      <MessagesList globalId={"messagesList"}/>
   </Page>
}
